import { FieldConfig } from '../components/TableSearch/types';
import { toAdvancedSearchConfig as toProductsSearchConfig } from '../domains/products/adapters';
import { toAdvancedSearchConfig as toManufacturersSearchConfig } from '../domains/manufacturers/adapters';
import { toAdvancedSearchConfig as toGradesSearchConfig } from '../domains/grades/adapters';
import { toTherapeuticAreasSearchConfig } from '../domains/therapeutic-areas/adapters';
import { toAuditLogsSearchConfig } from '../domains/audit/adapters';
import { toAdvancedSearchConfig as toFacilitiesSearchConfig } from '../domains/facilities/adapters';

/**
 * Field configuration for Products advanced search
 * Generated from Product Field Registry
 */
export const productsFieldConfig: FieldConfig[] = toProductsSearchConfig();

/**
 * Field configuration for Manufacturers advanced search
 * Generated from Manufacturer Field Registry
 */
export const manufacturersFieldConfig: FieldConfig[] =
  toManufacturersSearchConfig();

/**
 * Field configuration for Facilities advanced search
 * Generated from Facility Field Registry
 */
export const facilitiesFieldConfig: FieldConfig[] = toFacilitiesSearchConfig();

/**
 * Field configuration for Grades advanced search
 */
export const gradesFieldConfig: FieldConfig[] = toGradesSearchConfig();

/**
 * Field configuration for Therapeutic Areas advanced search
 */
export const therapeuticAreasFieldConfig: FieldConfig[] =
  toTherapeuticAreasSearchConfig();

/**
 * Field configuration for Audit Logs advanced search
 * Generated from Audit Log Field Registry
 */
export const auditLogsFieldConfig: FieldConfig[] = toAuditLogsSearchConfig();
